import BriefHistory from "./BriefHistory";

export default BriefHistory;